
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M12.61 15.417V14.03a2.777 2.777 0 0 0-2.776-2.776H4.282a2.776 2.776 0 0 0-2.776 2.776v1.388M7.058 8.477a2.776 2.776 0 1 0 0-5.553 2.776 2.776 0 0 0 0 5.553"}}),_c('path',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","d":"M12.542 9.456h4.008M14.538 7.478v3.981"}})])
          )
        }
      }
    